var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import OpenAI from "openai";
import { getClientSideEnvVar } from "./envUtils";
var AITextInlineTool = /** @class */ (function () {
    function AITextInlineTool(_a) {
        var api = _a.api, config = _a.config;
        this.button = null;
        this.tag = "SPAN";
        this.isProcessing = false;
        this.previewSpan = null;
        this.originalText = "";
        this.controlsContainer = null;
        this.currentRange = null;
        this.currentSelectedText = "";
        this.actionsContainer = null;
        this.outsideClickHandler = null;
        this.api = api;
        // Priority: config.apiKey > environment variables
        this._apiKey = (config === null || config === void 0 ? void 0 : config.apiKey) || getClientSideEnvVar('OPENAI_API_KEY') || "";
        this._maxTokens = (config === null || config === void 0 ? void 0 : config.maxTokens) || 8000;
        this._openai = new OpenAI({
            apiKey: this._apiKey,
            dangerouslyAllowBrowser: true,
        });
    }
    Object.defineProperty(AITextInlineTool, "isInline", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AITextInlineTool, "sanitize", {
        get: function () {
            return {
                span: {
                    class: "ai-inline-text",
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    AITextInlineTool.prototype.render = function () {
        this.button = document.createElement("button");
        this.button.type = "button";
        this.button.innerHTML = "Ai";
        this.button.classList.add("ce-inline-tool");
        this.button.style.fontWeight = "bold";
        this.button.style.fontSize = "14px";
        this.button.title = "AI Transform";
        return this.button;
    };
    AITextInlineTool.prototype.surround = function (range) {
        if (this.isProcessing)
            return;
        var selectedText = range.toString().trim();
        if (!selectedText) {
            console.warn("No text selected");
            return;
        }
        // Store the range and original text
        this.originalText = selectedText;
        this.currentRange = range.cloneRange();
        this.currentSelectedText = selectedText;
    };
    AITextInlineTool.prototype.checkState = function (selection) {
        return false;
    };
    AITextInlineTool.prototype.renderActions = function () {
        var _this = this;
        // Create outer container (vertical layout)
        this.actionsContainer = document.createElement("div");
        this.actionsContainer.style.cssText = "\n      display: flex !important;\n      flex-direction: column !important;\n      padding: 0 !important;\n      background: transparent !important;\n      border: none !important;\n      width: min(720px, calc(100vw - 32px)) !important;\n      max-width: calc(100vw - 32px) !important;\n      min-width: 0 !important;\n      overflow: visible !important;\n      gap: 8px !important;\n      box-sizing: border-box !important;\n    ";
        // Prompt textarea (no border/outline)
        var promptInput = document.createElement("textarea");
        promptInput.placeholder = "What to do? (e.g., summarize, rewrite)";
        promptInput.style.cssText = "\n      padding: 8px !important;\n      border: none !important;\n      outline: none !important;\n      background: #f5f5f5 !important;\n      border-radius: 6px !important;\n      font-size: 14px !important;\n      width: 100% !important;\n      height: 140px !important;\n      box-sizing: border-box !important;\n      resize: vertical !important;\n      white-space: pre-wrap !important;\n      font-family: inherit !important;\n    ";
        // Button container (aligned to the right)
        var buttonContainer = document.createElement("div");
        buttonContainer.style.cssText = "\n      display: flex !important;\n      justify-content: flex-end !important;\n      width: 100% !important;\n    ";
        // Arrow button (→) on the right
        var goButton = document.createElement("button");
        goButton.innerHTML = "→";
        goButton.style.cssText = "\n      padding: 8px 12px !important;\n      border: none !important;\n      border-radius: 4px !important;\n      background: #000 !important;\n      color: white !important;\n      cursor: pointer !important;\n      font-size: 16px !important;\n      font-weight: bold !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n      transition: background 0.2s !important;\n    ";
        goButton.onmouseover = function () { return goButton.style.background = "#333"; };
        goButton.onmouseout = function () { return goButton.style.background = "#000"; };
        goButton.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.handleGenerate(_this.currentSelectedText, promptInput.value, _this.currentRange);
        };
        // Allow Enter key to submit
        promptInput.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                e.stopPropagation();
                goButton.click();
            }
        });
        // Assemble container
        buttonContainer.appendChild(goButton);
        this.actionsContainer.appendChild(promptInput);
        this.actionsContainer.appendChild(buttonContainer);
        // Auto-focus the input
        setTimeout(function () { return promptInput.focus(); }, 0);
        return this.actionsContainer;
    };
    AITextInlineTool.prototype.handleGenerate = function (selectedText, userPrompt, range) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var editorElement, context, loadingSpinner;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!userPrompt.trim()) {
                            alert("Please enter a prompt");
                            return [2 /*return*/];
                        }
                        this.isProcessing = true;
                        editorElement = document.querySelector('.codex-editor');
                        if (editorElement) {
                            // Trigger a click on the editor to close the toolbar
                            editorElement.click();
                        }
                        // Small delay to ensure toolbar is closed
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 50); })];
                    case 1:
                        // Small delay to ensure toolbar is closed
                        _b.sent();
                        context = this.getSurroundingContext(range);
                        loadingSpinner = document.createElement("span");
                        loadingSpinner.className = "cdx-ai-text-loader";
                        loadingSpinner.style.cssText = "\n      margin-right: 4px;\n      display: inline-block;\n    ";
                        // Create preview span WITHOUT highlight initially (no background)
                        this.previewSpan = document.createElement("span");
                        this.previewSpan.textContent = selectedText; // Keep original text visible
                        this.previewSpan.style.cssText = "\n      padding: 2px 4px;\n      border-radius: 3px;\n      transition: background-color 0.3s;\n    ";
                        // Replace selected text with: [spinner][preview span]
                        range.deleteContents();
                        range.insertNode(this.previewSpan);
                        (_a = this.previewSpan.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(loadingSpinner, this.previewSpan);
                        // Generate with streaming
                        return [4 /*yield*/, this.generateTextWithStreaming(selectedText, userPrompt, context, this.previewSpan)];
                    case 2:
                        // Generate with streaming
                        _b.sent();
                        // Remove the loading spinner
                        if (loadingSpinner.parentNode) {
                            loadingSpinner.parentNode.removeChild(loadingSpinner);
                        }
                        // Add highlight ONLY after generation completes
                        this.previewSpan.style.backgroundColor = "#ADD8E6";
                        // Show accept/reject controls below the highlighted text
                        this.showAcceptRejectControls(this.previewSpan, range);
                        this.isProcessing = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AITextInlineTool.prototype.getSurroundingContext = function (range) {
        var _a;
        var blockElement = (_a = range.commonAncestorContainer.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-block]');
        if (blockElement) {
            return blockElement.textContent || "";
        }
        var parentElement = range.commonAncestorContainer.parentElement;
        return (parentElement === null || parentElement === void 0 ? void 0 : parentElement.textContent) || "";
    };
    AITextInlineTool.prototype.generateTextWithStreaming = function (selectedText, userPrompt, context, outputElement) {
        var _a, e_1, _b, _c;
        var _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var systemMessage, stream, fullText, _f, stream_1, stream_1_1, chunk, content, e_1_1, error_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 18, , 19]);
                        if (!this._apiKey) {
                            outputElement.textContent = "Error: No API key configured.";
                            return [2 /*return*/];
                        }
                        systemMessage = "You are a helpful writing assistant. The user has selected some text and wants you to transform it.\n\nContext (full text): \"".concat(context, "\"\n\nSelected text: \"").concat(selectedText, "\"\n\nUser request: ").concat(userPrompt, "\n\nIMPORTANT: Provide ONLY the transformed text as your response. Do not use any markdown formatting (no asterisks, underscores, backticks, etc.). Do not add explanations or additional text. Output plain text only.");
                        return [4 /*yield*/, this._openai.chat.completions.create({
                                model: "gpt-4o-mini",
                                messages: [
                                    { role: "system", content: systemMessage },
                                    { role: "user", content: userPrompt },
                                ],
                                max_tokens: this._maxTokens,
                                stream: true,
                            })];
                    case 1:
                        stream = _g.sent();
                        fullText = "";
                        _g.label = 2;
                    case 2:
                        _g.trys.push([2, 11, 12, 17]);
                        _f = true, stream_1 = __asyncValues(stream);
                        _g.label = 3;
                    case 3: return [4 /*yield*/, stream_1.next()];
                    case 4:
                        if (!(stream_1_1 = _g.sent(), _a = stream_1_1.done, !_a)) return [3 /*break*/, 10];
                        _c = stream_1_1.value;
                        _f = false;
                        _g.label = 5;
                    case 5:
                        _g.trys.push([5, , 8, 9]);
                        chunk = _c;
                        content = ((_e = (_d = chunk.choices[0]) === null || _d === void 0 ? void 0 : _d.delta) === null || _e === void 0 ? void 0 : _e.content) || "";
                        if (!content) return [3 /*break*/, 7];
                        fullText += content;
                        outputElement.textContent = fullText;
                        // Small delay for smooth streaming effect
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 20); })];
                    case 6:
                        // Small delay for smooth streaming effect
                        _g.sent();
                        _g.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        _f = true;
                        return [7 /*endfinally*/];
                    case 9: return [3 /*break*/, 3];
                    case 10: return [3 /*break*/, 17];
                    case 11:
                        e_1_1 = _g.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 17];
                    case 12:
                        _g.trys.push([12, , 15, 16]);
                        if (!(!_f && !_a && (_b = stream_1.return))) return [3 /*break*/, 14];
                        return [4 /*yield*/, _b.call(stream_1)];
                    case 13:
                        _g.sent();
                        _g.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 16: return [7 /*endfinally*/];
                    case 17:
                        if (!fullText.trim()) {
                            outputElement.textContent = "Error: No content received from AI.";
                        }
                        return [3 /*break*/, 19];
                    case 18:
                        error_1 = _g.sent();
                        console.error("Error generating text:", error_1);
                        outputElement.textContent = "Error: ".concat(error_1 instanceof Error ? error_1.message : "Unknown error");
                        return [3 /*break*/, 19];
                    case 19: return [2 /*return*/];
                }
            });
        });
    };
    AITextInlineTool.prototype.showAcceptRejectControls = function (previewSpan, range) {
        var _this = this;
        // Create controls container
        this.controlsContainer = document.createElement("div");
        this.controlsContainer.style.cssText = "\n      display: inline-flex;\n      gap: 8px;\n      margin-left: 8px;\n      vertical-align: middle;\n    ";
        // Reject button (×) - red, no background/border
        var rejectButton = document.createElement("button");
        rejectButton.innerHTML = "×";
        rejectButton.title = "Reject";
        rejectButton.style.cssText = "\n      padding: 0;\n      border: none;\n      background: transparent;\n      cursor: pointer;\n      font-size: 20px;\n      font-weight: bold;\n      color: #dc3545;\n      transition: opacity 0.2s;\n    ";
        rejectButton.onmouseover = function () { return rejectButton.style.opacity = "0.7"; };
        rejectButton.onmouseout = function () { return rejectButton.style.opacity = "1"; };
        rejectButton.onclick = function () { return _this.rejectChange(previewSpan); };
        // Accept button (✓) - green, no background/border
        var acceptButton = document.createElement("button");
        acceptButton.innerHTML = "✓";
        acceptButton.title = "Accept";
        acceptButton.style.cssText = "\n      padding: 0;\n      border: none;\n      background: transparent;\n      cursor: pointer;\n      font-size: 20px;\n      font-weight: bold;\n      color: #28a745;\n      transition: opacity 0.2s;\n    ";
        acceptButton.onmouseover = function () { return acceptButton.style.opacity = "0.7"; };
        acceptButton.onmouseout = function () { return acceptButton.style.opacity = "1"; };
        acceptButton.onclick = function () { return _this.acceptChange(previewSpan); };
        // Add buttons to container
        this.controlsContainer.appendChild(rejectButton);
        this.controlsContainer.appendChild(acceptButton);
        // Insert controls right after the preview span
        if (previewSpan.parentNode) {
            previewSpan.parentNode.insertBefore(this.controlsContainer, previewSpan.nextSibling);
        }
        // Make the preview span clickable to restore controls if they get hidden
        // Use mousedown instead of onclick for contenteditable compatibility
        previewSpan.style.cursor = "pointer";
        previewSpan.style.userSelect = "none"; // Prevent text selection on click
        previewSpan.contentEditable = "false"; // Make span non-editable to capture clicks
        previewSpan.addEventListener("mousedown", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!_this.controlsContainer || !_this.controlsContainer.parentNode) {
                // Controls were removed, restore them
                _this.showAcceptRejectControls(previewSpan, range);
            }
        });
        // Setup outside click handler to hide controls but keep highlight
        this.setupOutsideClickHandler(previewSpan);
    };
    AITextInlineTool.prototype.setupOutsideClickHandler = function (previewSpan) {
        var _this = this;
        // Remove existing handler if any
        if (this.outsideClickHandler) {
            document.removeEventListener("click", this.outsideClickHandler);
        }
        // Create new handler
        this.outsideClickHandler = function (e) {
            var target = e.target;
            // Check if click is outside both the preview span and controls
            if (_this.previewSpan &&
                _this.controlsContainer &&
                !_this.previewSpan.contains(target) &&
                !_this.controlsContainer.contains(target)) {
                // Hide controls but keep highlight and span
                _this.removeControls();
            }
        };
        // Add listener with a small delay to avoid immediate triggering
        setTimeout(function () {
            if (_this.outsideClickHandler) {
                document.addEventListener("click", _this.outsideClickHandler);
            }
        }, 100);
    };
    AITextInlineTool.prototype.acceptChange = function (previewSpan) {
        // Remove highlight and controls, keep the generated text
        if (previewSpan && previewSpan.parentNode) {
            var generatedText = previewSpan.textContent || "";
            var parent_1 = previewSpan.parentNode;
            // Create text node and replace the span
            var textNode = document.createTextNode(generatedText);
            parent_1.replaceChild(textNode, previewSpan);
            // Force a reflow to ensure DOM is updated
            parent_1.normalize();
            // Trigger EditorJS change detection for undo support
            this.triggerEditorChange(parent_1);
        }
        // Clean up
        this.removeControls();
        this.cleanupEventHandlers();
        this.previewSpan = null;
    };
    AITextInlineTool.prototype.rejectChange = function (previewSpan) {
        // Remove highlight and controls, restore original text
        if (previewSpan && previewSpan.parentNode) {
            var parent_2 = previewSpan.parentNode;
            // Create text node with original text and replace the span
            var textNode = document.createTextNode(this.originalText);
            parent_2.replaceChild(textNode, previewSpan);
            // Force a reflow to ensure DOM is updated
            parent_2.normalize();
            // Trigger EditorJS change detection for undo support
            this.triggerEditorChange(parent_2);
        }
        // Clean up
        this.removeControls();
        this.cleanupEventHandlers();
        this.previewSpan = null;
    };
    AITextInlineTool.prototype.triggerEditorChange = function (node) {
        // Dispatch input event to trigger EditorJS's change detection
        var blockElement = node.closest('[contenteditable="true"]');
        if (blockElement) {
            var inputEvent = new Event('input', { bubbles: true, cancelable: true });
            blockElement.dispatchEvent(inputEvent);
        }
    };
    AITextInlineTool.prototype.cleanupEventHandlers = function () {
        // Remove outside click handler
        if (this.outsideClickHandler) {
            document.removeEventListener("click", this.outsideClickHandler);
            this.outsideClickHandler = null;
        }
    };
    AITextInlineTool.prototype.removeControls = function () {
        if (this.controlsContainer && this.controlsContainer.parentNode) {
            this.controlsContainer.parentNode.removeChild(this.controlsContainer);
            this.controlsContainer = null;
        }
    };
    AITextInlineTool.prototype.clear = function () {
        this.removeControls();
        this.cleanupEventHandlers();
        if (this.actionsContainer && this.actionsContainer.parentNode) {
            this.actionsContainer.parentNode.removeChild(this.actionsContainer);
            this.actionsContainer = null;
        }
    };
    return AITextInlineTool;
}());
export default AITextInlineTool;
